import { SasiType } from './Yubinuki';
import DrawDirection from './DrawDirection';

class SasiPositionCounter {
    // let
    direction: number;
    offsetMax: number;
    deltaMax: number;
    // var
    offset: number;
    deltaIndex: number;

    constructor(offsetMax: number, deltaMax: number, startOffset: number, sasiType: number) {
        this.direction = (sasiType === SasiType.NAMI) ? DrawDirection.RIGHT : DrawDirection.LEFT;
        this.offsetMax = offsetMax;
        this.deltaMax = deltaMax;

        if (sasiType === SasiType.NAMI) {
            this.offset = (offsetMax <= startOffset) ? startOffset - offsetMax : startOffset;
        } else {
            this.offset = ((startOffset - 1) < 0) ? startOffset - 1 + offsetMax : startOffset - 1;
        }
        this.deltaIndex = (sasiType === SasiType.NAMI) ? 0 : deltaMax - 1;
    }

    tick() {
        if (this.direction === DrawDirection.RIGHT) {
            this.deltaIndex += 1;
            if (this.deltaMax <= this.deltaIndex) {
                this.offset += 1
                if (this.offsetMax <= this.offset) {
                    this.offset -= this.offsetMax
                }
                this.deltaIndex -= this.deltaMax
            }
        } else {
            this.deltaIndex -= 1
            if (this.deltaIndex < 0) {
                this.offset -= 1
                if (this.offset < 0) {
                    this.offset += this.offsetMax;
                }
                this.deltaIndex += this.deltaMax;
            }
        }
    }
}

export default SasiPositionCounter;
